import React from 'react';
import { Box, Container, Heading, Text, VStack, HStack, Circle } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const WhyUsJourney = ({ data }) => {
  return (
    <Box py={{ base: 16, md: 20 }} bg="white">
      <Container maxW="container.lg">
        <VStack spacing={12}>
          <VStack spacing={4} textAlign="center">
            <Heading size="2xl" fontWeight="900" color="brand.800">
              {data.title}
            </Heading>
            <Text fontSize="lg" color="brand.500">
              {data.subtitle}
            </Text>
          </VStack>

          <VStack spacing={8} align="stretch" w="full" position="relative">
            {/* Timeline line */}
            <Box
              position="absolute"
              left={{ base: '20px', md: '50%' }}
              top="0"
              bottom="0"
              w="2px"
              bg="accent.green"
              opacity="0.3"
            />

            {data.milestones.map((milestone, index) => (
              <MotionBox
                key={index}
                initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >
                <HStack spacing={8} align="center">
                  <Circle
                    size="40px"
                    bg="accent.green"
                    color="white"
                    fontWeight="700"
                    position="relative"
                    zIndex={1}
                  >
                    {index + 1}
                  </Circle>
                  <Box flex={1} p={6} bg="brand.50" borderRadius="xl">
                    <Text fontWeight="700" color="accent.gold" fontSize="lg">
                      {milestone.year}
                    </Text>
                    <Heading size="md" color="brand.700" mt={2}>
                      {milestone.title}
                    </Heading>
                    <Text color="brand.500" mt={2}>
                      {milestone.desc}
                    </Text>
                  </Box>
                </HStack>
              </MotionBox>
            ))}
          </VStack>
        </VStack>
      </Container>
    </Box>
  );
};

export default WhyUsJourney;